import React, { createContext, useContext, useEffect, useState } from 'react';

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem('fpn_cart');
      return raw ? JSON.parse(raw) : [];
    } catch { return []; }
  });
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem('fpn_cart', JSON.stringify(items));
  }, [items]);

  const addItem = (product, qty = 1, flavor = null) => {
    setItems(prev => {
      const key = product.id + (flavor || '');
      const existing = prev.find(p => p.key === key);
      if (existing) {
        return prev.map(p => p.key === key ? { ...p, qty: p.qty + qty } : p);
      }
      return [...prev, { key, id: product.id, name: product.name, price: product.price, image: product.image, flavor, qty }];
    });
    setIsOpen(true);
  };

  const removeItem = (key) => setItems(prev => prev.filter(p => p.key !== key));
  const updateQty = (key, qty) => {
    if (qty <= 0) return removeItem(key);
    setItems(prev => prev.map(p => p.key === key ? { ...p, qty } : p));
  };
  const clear = () => setItems([]);

  const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);
  const count = items.reduce((s, i) => s + i.qty, 0);

  return (
    <CartContext.Provider value={{ items, count, subtotal, addItem, removeItem, updateQty, clear, isOpen, setIsOpen }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
